var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBarcode = function SvgBarcode(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.88 113.66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7b8fb5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tareas"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.53,1.53H4.45a2,2,0,0,0-2,2v18a2,2,0,0,0,4,0v-16H18.53a2,2,0,0,0,0-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.91,1.53H86.83a2,2,0,0,0,0,4H98.91v16a2,2,0,0,0,4,0v-18A2,2,0,0,0,100.91,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.53,108.13H6.45v-16a2,2,0,0,0-4,0v18a2,2,0,0,0,2,2H18.53a2,2,0,0,0,0-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.91,90.11a2,2,0,0,0-2,2v16H86.83a2,2,0,1,0,0,4h14.08a2,2,0,0,0,2-2v-18A2,2,0,0,0,100.91,90.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,100.87V12.1a2,2,0,0,0-4,0v88.77a2,2,0,0,0,4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.49,10.1a2,2,0,0,0-2,2v88.77a2,2,0,0,0,4,0V12.1A2,2,0,0,0,37.49,10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.21,10.1a2,2,0,0,0-2,2v88.77a2,2,0,0,0,4,0V12.1A2,2,0,0,0,47.21,10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.13,100.87V12.1a2,2,0,1,0-4,0v88.77a2,2,0,0,0,4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.94,10.1a2,2,0,0,0-2,2v88.77a2,2,0,0,0,4,0V12.1A2,2,0,0,0,56.94,10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.4,10.31a3,3,0,0,0-3,3V99.65a3,3,0,0,0,6,0V13.31A3,3,0,0,0,76.4,10.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.76,10.24a1,1,0,0,0-1,1v90.51a1,1,0,0,0,2,0V11.24A1,1,0,0,0,27.76,10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.67,10.24a1,1,0,0,0-1,1v90.51a1,1,0,0,0,2,0V11.24A1,1,0,0,0,66.67,10.24Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBarcode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "barcode.9deb99352e44c2d05c1151d03db1bf75.svg";